module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("io3B6"))).then(() => parcelRequire('d0iPb'));